import {
  call, takeLatest, put,
} from 'redux-saga/effects';
import { apiFetchGlobalPresetImpc, apiFetchGlobalPresetOperator } from '../../api/GlobalPresetPerAssetTypeAPI';
import {
  FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_REQUEST,
  FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_REQUEST,
} from '../actions/types/GlobalPresetPerAssetTypeActionTypes';
import {
  getGlobalPresetImpcSuccessActionCreator,
  getGlobalPresetImpcFailureActionCreator,
  getGlobalPresetOperatorSuccessActionCreator,
  getGlobalPresetOperatorFailureActionCreator,
} from '../actions/GlobalPresetPerAssetTypeActions';

function* doGlobalPresetImpcApplyWorker(action) {
  try {
    const res = yield call(apiFetchGlobalPresetImpc, action.payload);
    yield put(getGlobalPresetImpcSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getGlobalPresetImpcFailureActionCreator(error));
  }
}

function* doGlobalPresetOperatorApplyWorker(action) {
  try {
    const res = yield call(apiFetchGlobalPresetOperator, action.payload);
    yield put(getGlobalPresetOperatorSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getGlobalPresetOperatorFailureActionCreator(error));
  }
}

function* doGlobalPresetApplyWatcher() {
  yield takeLatest(FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_REQUEST, doGlobalPresetImpcApplyWorker);
  yield takeLatest(FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_REQUEST, doGlobalPresetOperatorApplyWorker);
}

export default doGlobalPresetApplyWatcher;
